import ROUTES from './routes';

export const sidebarItems = [
  { title: 'Master/Slaves', link: '/master-slaves', key: 'masterSlaves', icon: 'mdi-account-child-outline' },
  { title: 'Apps > Services', link: '/services', key: 'services', icon: 'mdi-hammer-screwdriver' },
  { title: 'Apps > Rubix', link: '/rubix-apps', key: 'rubixApps', icon: 'mdi-apps' },
  { title: 'Apps > BIOS Apps', link: '/slaves-bios-apps', key: 'slaveBiosApps', icon: 'mdi-graph-outline' },
  // { title: 'Config > IO 10', link: '/io-10-config', key: 'io10Config', icon: 'mdi-chemical-weapon' },
  { title: 'Config > Point Mapping', link: '/service-mapping', key: 'serviceMapping', icon: 'mdi-map' },
  { title: 'Console > MQTT', link: '/mqtt', key: 'mqtt', icon: 'mdi-protocol' },
  { title: 'Console > REST', link: '/api-client', key: 'apiClient', icon: 'mdi-api' },
  { title: 'Console > Logging', link: '/logging', key: 'logging', icon: 'mdi-history' },
  { title: 'Console > Ip Scan', link: '/ip-scanning', key: 'ipScanning', icon: 'mdi-magnify-scan' },
  { title: 'Driver > Rubix', link: '/rubix-driver', key: 'cloudNetworks', icon: 'mdi-cloud' },
  { title: 'Driver > Modbus Master', link: '/modbus', key: 'modbus', icon: 'mdi-table' },
  { title: 'Driver > BACnet Master', link: '/bacnet-master', key: 'bacnetMaster', icon: 'mdi-source-fork' },
  { title: 'Driver > BACnet Server', link: '/bacnet-server', key: 'bacnetServer', icon: 'mdi-server' },
  { title: 'Driver > LoRa Network', link: '/lora-network', key: 'lora', icon: 'mdi-motion-sensor' },
  { title: 'Schedules', link: '/schedules', key: 'schedules', icon: 'mdi-calendar-plus' },
  { title: 'User Management', link: '/user-management', key: 'userManagement', icon: 'mdi-account' },
  { title: 'Host > File Manager', link: '/file', key: 'fileManager', icon: 'mdi-file' },
  { title: 'Host > Backup/Restore', link: '/app-manager', key: 'appManager', icon: 'mdi-backup-restore' },
  {
    title: 'Plugins Distro',
    link: ROUTES.rfFrameworkUpgrade,
    key: 'pluginDistro',
    dependentKey: 'rubixFlow',
    icon: 'mdi-power-socket-au',
  },
  { title: 'Plugins', link: '/plugins', key: 'plugins', icon: 'mdi-puzzle', dependentKey: 'rubixFlow' },
  {
    title: 'Rubix Flow Network',
    link: ROUTES.rfFlowNetworkRoot,
    key: 'flowNetwork',
    icon: 'mdi-view-stream',
    dependentKey: 'rubixFlow',
  },
  {
    title: 'Rubix Flow Network Clone',
    link: ROUTES.rfFlowNetworkCloneRoot,
    key: 'flowNetworkClone',
    icon: 'mdi-view-stream',
    dependentKey: 'rubixFlow',
  },
  {
    title: 'RF > Networks',
    link: ROUTES.rfNetworkDevicePoint,
    key: 'flowNetworkNDP',
    icon: 'mdi-server-network',
    dependentKey: 'rubixFlow',
  },
  {
    title: 'RF > All Network Devices',
    link: ROUTES.rfAllNetworkDevices,
    key: 'rubixFlowAllNetworkDevices',
    icon: 'mdi-application',
    dependentKey: 'rubixFlow',
  },
  {
    title: 'RF > All Points',
    link: ROUTES.rfAllPoints,
    key: 'rubixFlowAllPoints',
    icon: 'mdi-application',
    dependentKey: 'rubixFlow',
  },
  {
    title: 'RF Schedules',
    link: ROUTES.rfSchedules,
    key: 'rfSchedules',
    icon: 'mdi-calendar',
    dependentKey: 'rubixFlow',
  },
];

export const serviceItems = [
  { id: 'BACNET_SERVER', name: 'rubix-bacnet-server', fileName: 'nubeio-bacnet-server.service' },
  { id: 'LORA_RAW', name: 'lora-raw', fileName: 'nubeio-lora-raw.service' },
  { id: 'POINT_SERVER', name: 'rubix-point-server', fileName: 'nubeio-point-server.service' },
  { id: 'RUBIX_PLAT', name: 'rubix-plat-build', fileName: 'rubix' },
  { id: 'WIRES', name: 'wires-builds', fileName: 'nubeio-rubix-wires.service' },
];

export const units = [
  'metersPerSecondPerSecond',
  'squareMeters',
  'squareCentimeters',
  'squareFeet',
  'squareInches',
  'currency1',
  'currency2',
  'currency3',
  'currency4',
  'currency5',
  'currency6',
  'currency7',
  'currency8',
  'currency9',
  'currency10',
  'milliamperes',
  'amperes',
  'amperesPerMeter',
  'amperesPerSquareMeter',
  'ampereSquareMeters',
  'decibels',
  'decibelsMillivolt',
  'decibelsVolt',
  'farads',
  'henrys',
  'ohms',
  'ohmMeters',
  'ohmMeterPerSquareMeter',
  'milliohms',
  'kilohms',
  'megohms',
  'microSiemens',
  'millisiemens',
  'siemens',
  'siemensPerMeter',
  'teslas',
  'volts',
  'millivolts',
  'kilovolts',
  'megavolts',
  'voltAmperes',
  'kilovoltAmperes',
  'megavoltAmperes',
  'ampereSeconds',
  'ampereSquareHours',
  'voltAmpereHours',
  'kilovoltAmpereHours',
  'megavoltAmpereHours',
  'voltAmperesReactive',
  'kilovoltAmperesReactive',
  'megavoltAmperesReactive',
  'voltAmpereHoursReactive',
  'kilovoltAmpereHoursReactive',
  'megavoltAmpereHoursReactive',
  'voltsPerDegreeKelvin',
  'voltsPerMeter',
  'voltsSquareHours',
  'degreesPhase',
  'powerFactor',
  'webers',
  'joules',
  'kilojoules',
  'kilojoulesPerKilogram',
  'megajoules',
  'joulesPerHours',
  'wattHours',
  'kilowattHours',
  'megawattHours',
  'wattHoursReactive',
  'kilowattHoursReactive',
  'megawattHoursReactive',
  'btus',
  'kiloBtus',
  'megaBtus',
  'therms',
  'tonHours',
  'joulesPerKilogramDryAir',
  'kilojoulesPerKilogramDryAir',
  'megajoulesPerKilogramDryAir',
  'btusPerPoundDryAir',
  'btusPerPound',
  'joulesPerDegreeKelvin',
  'kilojoulesPerDegreeKelvin',
  'megajoulesPerDegreeKelvin',
  'joulesPerKilogramDegreeKelvin',
  'newton',
  'cyclesPerHour',
  'cyclesPerMinute',
  'hertz',
  'kilohertz',
  'megahertz',
  'perHour',
  'gramsOfWaterPerKilogramDryAir',
  'percentRelativeHumidity',
  'micrometers',
  'millimeters',
  'centimeters',
  'kilometers',
  'meters',
  'inches',
  'feet',
  'candelas',
  'candelasPerSquareMeter',
  'wattsPerSquareFoot',
  'wattsPerSquareMeter',
  'lumens',
  'luxes',
  'footCandles',
  'milligrams',
  'grams',
  'kilograms',
  'poundsMass',
  'tons',
  'gramsPerSecond',
  'gramsPerMinute',
  'kilogramsPerSecond',
  'kilogramsPerMinute',
  'kilogramsPerHour',
  'poundsMassPerSecond',
  'poundsMassPerMinute',
  'poundsMassPerHour',
  'tonsPerHour',
  'milliwatts',
  'watts',
  'kilowatts',
  'megawatts',
  'btusPerHour',
  'kiloBtusPerHour',
  'horsepower',
  'tonsRefrigeration',
  'pascals',
  'hectopascals',
  'kilopascals',
  'pascalSeconds',
  'millibars',
  'bars',
  'poundsForcePerSquareInch',
  'millimetersOfWater',
  'centimetersOfWater',
  'inchesOfWater',
  'millimetersOfMercury',
  'centimetersOfMercury',
  'inchesOfMercury',
  'degreesCelsius',
  'degreesKelvin',
  'degreesKelvinPerHour',
  'degreesKelvinPerMinute',
  'degreesFahrenheit',
  'degreeDaysCelsius',
  'degreeDaysFahrenheit',
  'deltaDegreesFahrenheit',
  'deltaDegreesKelvin',
  'years',
  'months',
  'weeks',
  'days',
  'hours',
  'minutes',
  'seconds',
  'hundredthsSeconds',
  'milliseconds',
  'newtonMeters',
  'millimetersPerSecond',
  'millimetersPerMinute',
  'metersPerSecond',
  'metersPerMinute',
  'metersPerHour',
  'kilometersPerHour',
  'feetPerSecond',
  'feetPerMinute',
  'milesPerHour',
  'cubicFeet',
  'cubicFeetPerDay',
  'cubicMeters',
  'cubicMetersPerDay',
  'imperialGallons',
  'milliliters',
  'liters',
  'usGallons',
  'cubicFeetPerSecond',
  'cubicFeetPerMinute',
  'cubicFeetPerHour',
  'cubicMetersPerSecond',
  'cubicMetersPerMinute',
  'cubicMetersPerHour',
  'imperialGallonsPerMinute',
  'millilitersPerSecond',
  'litersPerSecond',
  'litersPerMinute',
  'litersPerHour',
  'usGallonsPerMinute',
  'usGallonsPerHour',
  'degreesAngular',
  'degreesCelsiusPerHour',
  'degreesCelsiusPerMinute',
  'degreesFahrenheitPerHour',
  'degreesFahrenheitPerMinute',
  'jouleSeconds',
  'kilogramsPerCubicMeter',
  'kilowattHoursPerSquareMeter',
  'kilowattHoursPerSquareFoot',
  'megajoulesPerSquareMeter',
  'megajoulesPerSquareFoot',
  'noUnits',
  'newtonSeconds',
  'newtonsPerMeter',
  'partsPerMillion',
  'partsPerBillion',
  'percent',
  'percentObscurationPerFoot',
  'percentObscurationPerMeter',
  'percentPerSecond',
  'perMinute',
  'perSecond',
  'psiPerDegreeFahrenheit',
  'radians',
  'radiansPerSecond',
  'revolutionsPerMinute',
  'squareMetersPerNewton',
  'wattsPerMeterPerDegreeKelvin',
  'wattsPerSquareMeterDegreeKelvin',
  'perMille',
  'gramsPerGram',
  'kilogramsPerKilogram',
  'gramsPerKilogram',
  'milligramsPerGram',
  'milligramsPerKilogram',
  'gramsPerMilliliter',
  'gramsPerLiter',
  'milligramsPerLiter',
  'microgramsPerLiter',
  'gramsPerCubicMeter',
  'milligramsPerCubicMeter',
  'microgramsPerCubicMeter',
  'nanogramsPerCubicMeter',
  'gramsPerCubicCentimeter',
  'wattHoursPerCubicMeter',
  'joulesPerCubicMeter',
  'becquerels',
  'kilobecquerels',
  'megabecquerels',
  'gray',
  'milligray',
  'microgray',
  'sieverts',
  'millisieverts',
  'microsieverts',
  'microsievertsPerHour',
  'decibelsA',
  'nephelometricTurbidityUnit',
  'pH',
  'gramsPerSquareMeter',
  'minutesPerDegreeKelvin',
];

export const START_APP = 'start';
export const RESTART_APP = 'restart';
export const STOP_APP = 'stop';
export const REFRESH_APP = 'refresh';
export const ENABLE_APP = 'enable';
export const DISABLE_APP = 'disable';
export const CRON_APP = 'cron';

export const RUBIX_APP_STATUS_CONTROL_ACTIONS = {
  STOP: STOP_APP,
  START: START_APP,
  RESTART: RESTART_APP,
  REFRESH: REFRESH_APP,
  ENABLE: ENABLE_APP,
  DISABLE: DISABLE_APP,
  CRON: CRON_APP,
};

export const RUBIX_APP_TYPES = {
  INSTALLER: 'Installer',
  FRONTEND_APP: 'FrontendApp',
  PYTHON_APP: 'PythonApp',
  APT_APP: 'AptApp',
  OTHERS: 'Others',
};

export const ENV_CONFIG_TYPE = '.env';
export const JSON_CONFIG_TYPE = '.json';
export const OPENVPN_CONFIG_TYPE = '.openvpn';

export const APP_CONFIG_TYPES = {
  [RUBIX_APP_TYPES.FRONTEND_APP]: ENV_CONFIG_TYPE,
  [RUBIX_APP_TYPES.PYTHON_APP]: JSON_CONFIG_TYPE,
  [RUBIX_APP_TYPES.APT_APP]: OPENVPN_CONFIG_TYPE,
};

export const ALWAYS_RUNNING_RUBIX_APP = {
  RUBIX_PLAT: 'RUBIX_PLAT',
};

export const SERVICE_NAMES = {
  RUBIX_BIOS: 'rubixBios',
  RUBIX_SERVICE: 'rubixService',
};
export const MODBUS_RTU_PORTS = ['/dev/ttyUSB0', '/dev/ttyUSB1', '/dev/ttyUSB2', '/dev/ttyUSB3', '/dev/ttyUSB4'];

export const APP_DOWNLOAD_STATUSES = {
  DOWNLOAD_IN_PROGRESS: 'DOWNLOAD_IN_PROGRESS',
  DOWNLOAD_COMPLETE: 'DOWNLOAD_COMPLETE',
};

export const DATA_TABLE_PROPS = {
  FOOTER_PROPS: {
    showFirstLastPage: true,
    firstIcon: 'mdi-chevron-double-left',
    lastIcon: 'mdi-chevron-double-right',
    prevIcon: 'mdi-chevron-left',
    nextIcon: 'mdi-chevron-right',
    itemsPerPageOptions: [10, 25, 50, -1],
  },
  ITEMS_PER_PAGE: 50,
};

export const USER_VERIFICATION_STATE = {
  VERIFIED: 'VERIFIED',
  UNVERIFIED: 'UNVERIFIED',
};

export const MAPPING_STATE = {
  MAPPED: 'MAPPED',
  BROKEN: 'BROKEN',
};
